import "./Main.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, Link} from 'react-router-dom'; // Added Navigate
import { useState,useEffect } from "react";
import PC from "../RazerProject/PC";
import Home from "./Home";
import Mobile from "./Mobile";
import Service from "./Service";
import Error from "./Error";
import Login from "./Login";
import Store from "./Store";
import SearchMobile from "./SearchItems/SearchMobile";
import SearchLaptop from "./SearchItems/SearchLaptop";
import UserCart from "./UserCart";
import { useCart } from "./CartContext";
import SearchKeyBoard from "./SearchItems/SearchKeyBoard";
import SearchHeadset from "./SearchItems/SearchHeadset";

function Main() {

  return (
    <BrowserRouter>
      <Nav/>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/store' element={<Store />} />
        <Route path='/pc' element={<PC />} />
        <Route path='/mobile' element={<Mobile />} />
        <Route path='/service' element={<Service/>} />
        <Route path='/login' element={<Login/>} />
        <Route path="/search/mobiles" element={<SearchMobile/>} />
        <Route path="/search/laptops" element={<SearchLaptop/>} />
        <Route path="/search/keyboards" element={<SearchKeyBoard/>} />
        <Route path="/search/headsets" element={<SearchHeadset/>} />
        <Route path="/usercart" element={<UserCart/>} />
        <Route path='*' element={<Error/>} />
       </Routes>
    </BrowserRouter>
  );

  function Nav() {

    const [inputValue, setInputValue] = useState('');
    // show number on cart
    const {cartItems} =useCart();

    const handleInputChange = (event) => {
      setInputValue(event.target.value.toLowerCase().trim());
    };

    const handleInputSubmit = (event) => {
      if (event.key === 'Enter') {
        if (inputValue === 'mobile' || inputValue === 'mobiles') {
          window.location.href = `/search/mobiles`;
        }
        if (inputValue === 'laptop' || inputValue === 'laptops') {
          window.location.href = `/search/laptops`;
        }
        if (inputValue === 'keyboards' || inputValue === 'keyboard') {
          window.location.href = `/search/keyboards`;
        }
        if (inputValue === 'headsets' || inputValue === 'headset') {
          window.location.href = `/search/headsets`;
        }
        setInputValue('');
      }
    };
    

//     //dynamic placeholder names change function
    
// const SearchBar = () => {
  const [placeholder, setPlaceholder] = useState('Search...');

  useEffect(() => {
      const words = ['laptops', 'mobiles', 'keyboards', 'headphones']; // Array of words
      let index = 0;

      const interval = setInterval(() => {
          setPlaceholder(words[index]);
          index = (index + 1) % words.length; // Move to the next word, looping back to the beginning if needed
      }, 2000); // Change placeholder every 2 seconds

      return () => clearInterval(interval); // Cleanup on unmount
  }, []);

    return (
      <div style={{ backgroundColor: "black" }} className="MainDiv">
        <div>
          <nav className="navbar navbar-expand-md navbar-dark bg-dark">
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <Link to="/" className="navbar-brand ms-5">
              <img src="https://assets2.razerzone.com/images/phoenix/razer-ths-logo.svg" alt="" className="logo" />
            </Link>
            {/* big screen search bar */}
            <div>
              <div className="srch-div">
                <i className="fa-solid fa-xmark srch-div-Xicon" onClick={() => { document.querySelector(".srch-div").style.display = "none"; document.querySelector(".navbar-nav").style.display = "block"; document.querySelector(".navbar-nav").style.display = "flex"; }}></i>
                <input type="text" className="srch1" placeholder={placeholder} value={inputValue} onChange={handleInputChange} onKeyDown={handleInputSubmit}></input>
                <i className="fa fa-search srch-div-icon"></i>
              </div>
            </div>
            {/* --------shopping cart--icon------ */}
            <Link to="/usercart">
              <button className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#cartbar">
                <span className=""><i className="fa-solid fa-cart-shopping"></i> <sup className="text-success" style={{fontSize:"18px",fontWeight:"bolder"}}>{cartItems.length}</sup></span>
              </button>
            </Link>
              {/* --- */}  
            <div className="collapse navbar-collapse mt-2 justify-content-center me-5 pe-5" id="navbarNav">
           {/* -----small screen search bar */}
              <div>
                <input type="text" className="form-control d-md-none ms-5 m-2" placeholder={placeholder} value={inputValue} onChange={handleInputChange} onKeyDown={handleInputSubmit}></input>
              </div>
              {/* ---- */}
              <ul className="navbar-nav" onClick={() => {
                const navbarCollapse = document.getElementById('navbarNav');
                if (navbarCollapse.classList.contains('show')) {
                  navbarCollapse.classList.remove('show');
                }
              }}>
                <li className="nav-item">
                  <Link to="/" className="nav-link ps-4 ms-4 me-3">Home</Link>
                </li>
                <li className="nav-item">
                  <Link to="/store" className="nav-link ps-4 ms-4 me-3">Store</Link>
                </li>
                <li className="nav-item">
                  <Link to="/pc" className="nav-link ps-4 ms-4 me-3">PC</Link>
                </li>
                <li className="nav-item">
                  <Link to="/mobile" className="nav-link ps-4 ms-4 me-3">Mobile</Link>
                </li>
                <li className="nav-item">
                  <Link to="/service" className="nav-link ps-4 ms-4 me-3">Service</Link>
                </li>
                <li className="nav-item">
                  <Link to="/login" className="nav-link ps-4 ms-4">Login</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link ps-4 d-none d-lg-block ms-5">
                    <i className="fa fa-search" onClick={() => { document.querySelector(".srch-div").style.display = "block"; document.querySelector(".navbar-nav").style.display = "none"; }}></i>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/usercart" className="nav-link ps-4 d-none d-lg-block ms-5"><i className="fa fa-shopping-cart"> <sup className="text-success"  style={{fontSize:"18px",fontWeight:"bolder"}}>{cartItems.length}</sup></i></Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <div style={{ height: "auto", background: "#555", margin: "-9px 0px 0px", padding: "1px", width: "100vw", zIndex: "12" }}>
          <p style={{ justifyContent: "center", textAlign: "center", color: "white", marginTop: "14px" }}>For a limited time, all orders will
            enjoy free shipping to the United States.<span href="#" style={{ cursor: "pointer", color: "green" }}>&nbsp;Shop Now &gt;</span></p>
        </div>

        {/* ---------cart function ---------- */}

      </div>
    )
  }
}

export default Main;
